import { Component, Input, OnInit, inject } from "@angular/core";
import { RadioOption } from "@app/controls/testing/advanced/detail-new/common/eff-radio-group/models/radio-option.model";
import { SampleType } from "@app/controls/testing/advanced/shared/enums";
import { AdvEffDataService } from "@app/controls/testing/advanced/shared/services";
import {
    EffectivenessModel,
    EffectivenessSourceDocumentsModel,
    WorkflowGenerateSamplesModel,
} from "@app/controls/testing/advanced/shared/models";
import { ExcelHelper } from "@app/shared/helpers/excel-helper";
import { DocumentModel } from "@models/documents/documentmodel";
import { SampleTypeFormGroup } from "./models/sample-type-form-group.model";
import { debounceTime, distinctUntilChanged, firstValueFrom } from "rxjs";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";
import { EffRadioGroupComponent } from "@app/controls/testing/advanced/detail-new/common/eff-radio-group/eff-radio-group.component";
import { EffInputComponent } from "@app/controls/testing/advanced/detail-new/common/eff-input/eff-input.component";

@Component({
    selector: "sample-type-step",
    templateUrl: "./sample-type-step.component.html",
    styleUrls: ["./sample-type-step.component.scss"],
    imports: [TranslatePipe, EffRadioGroupComponent, EffInputComponent],
    viewProviders: [provideTranslationScope(scope)]
})
export class SampleTypeStepComponent implements OnInit {

    @Input() sampleTypes: any[] = [];
    @Input() samplingInformation: WorkflowGenerateSamplesModel;
    @Input() sourceDocumentModel: EffectivenessSourceDocumentsModel;
    @Input() effectivenessModel: EffectivenessModel;
    @Input() sampleFormGroup: SampleTypeFormGroup;
    @Input() isAutomatic: boolean;

    sampleTypeOptions: RadioOption[] = [];
    exceldocument: DocumentModel;

    private _ds = inject(AdvEffDataService);

    ngOnInit() {
        let visibleSocuments = this.sourceDocumentModel.documents.filter((doc) => !doc.Deleted);
        let excelSourceDocuments =
            visibleSocuments.length == 1
                ? visibleSocuments.filter((x) => x.Name.toLowerCase().endsWith(".xlsx"))
                : visibleSocuments.filter(
                      (x) => x.IsSelected && x.Name.toLowerCase().endsWith(".xlsx")
                  );

        if (excelSourceDocuments.length > 0) {
            this.exceldocument = excelSourceDocuments[0];
            this.sampleFormGroup.documentIdFormControl.setValue(this.exceldocument.Guid);
        } else {
            this.sampleTypes = this.sampleTypes.filter((s) => s.ID != 3); //spreadsheet
        }

        this.sampleTypeOptions = this.sampleTypes.map((type) => {
            return { id: type.ID, name: type.Name };
        });

        this.sampleFormGroup.init(this.samplingInformation);
        this.sampleFormGroup.idColumnFormControl.valueChanges
            .pipe(debounceTime(2000), distinctUntilChanged())
            .subscribe(() => {
                this.getMaximumPopulation(this);
            });
        this.sampleFormGroup.rowsToSkipFormControl.valueChanges
            .pipe(debounceTime(2000), distinctUntilChanged())
            .subscribe(() => {
                this.getMaximumPopulation(this);
            });
        if (this.effectivenessModel.useControlExecution) {
            this.sampleFormGroup.populationSizeFormControl.setValue(
                this.samplingInformation.populationSize
            );
        }
    }

    sampleTypeChanged() {
        this.sampleFormGroup.init(this.samplingInformation);
        if (this.isSpreadsheet()) {
            this.sampleFormGroup.populationSizeFormControl.setValue("");
        }
    }

    hidePopulationSize() {
        return this.samplingInformation.sampleType == SampleType.date;
    }

    isSpreadsheet() {
        return this.samplingInformation.sampleType == SampleType.spreadsheet;
    }

    hasValue(value) {
        return value != null && value != undefined && value != "";
    }

    async getMaximumPopulation(that: SampleTypeStepComponent) {
        if (
            that.sampleFormGroup.idColumnFormControl.invalid ||
            that.sampleFormGroup.rowsToSkipFormControl.invalid
        ) {
            that.sampleFormGroup.populationSizeFormControl.setValue("");
            return;
        }

        if (
            !that.hasValue(that.sampleFormGroup.idColumnFormControl.value) ||
            !that.hasValue(that.sampleFormGroup.rowsToSkipFormControl.value)
        ) {
            return;
        }

        var idColumn = ExcelHelper.convertExcelColumnToNumber(
            that.sampleFormGroup.idColumnFormControl.value
        );

        let maximumPopulation = await firstValueFrom(
            that._ds.getPopulation(
                that.effectivenessModel.guid,
                that.sampleFormGroup.documentIdFormControl.value,
                idColumn,
                that.sampleFormGroup.rowsToSkipFormControl.value
            )
        );

        that.sampleFormGroup.populationSizeFormControl.setValue(maximumPopulation);
    }
}
